/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import axios from 'axios';
import api from './api.services';
import {fetchApiDataFailure} from "../_actions/common.actions";
import {setSearchResult} from "../_actions/search.actions";
import {getCSGQueryString, getFieldsToReturn} from '../_helpers/search/keywordSearch';

export const csgSearch = (params) => dispatch => {
  
    const {title,resetResult, activeCollection} = params;
    const searchTerm = title;
    const searchFields = [];
    const startIndex = 0;
    const { queryString, must, should, should_not } = getCSGQueryString('Textbook', searchFields, searchTerm, 'Textbook', activeCollection);
    const payload = {
        queryString,
        fieldsToReturn: getFieldsToReturn(),
        responseSize: 12,
        startIndex: startIndex,
        sort: {},
        activeCollection,
        advancedFilter: { must, should, should_not }
    };
  
    axios.post(api.csg_search, payload)
        .then(response => {
            dispatch(setSearchResult({result: response.data, resetResult: resetResult}));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });
};



// WEBPACK FOOTER //
// ./src/_thunks/search.thunk.js